
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as queryString from 'query-string';


interface Props extends RouteComponentProps<{}> { }

class BmxOauthSignRedirectRoute extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.state = {
            query: queryString.parse(props.location.search)
        };
    }

}
export default BmxOauthSignRedirectRoute;




// WEBPACK FOOTER //
// ./src/components/pages/admin/BmxOauthSignRedirectRoute.tsx